export default __webpack_public_path__ + "static/media/CelciusWhiteLogo.450868a8.svg";